module.exports = __webpack_public_path__ + "img/newsbg.6743b857.png";